import { SupportLayerProvider } from '@creditornot/support-layer';
import * as React from 'react';
import { ComponentProps, ReactNode } from 'react';
import { useIntl } from 'react-intl';

import '@creditornot/support-layer/dist/style.css';

import useUser from 'common/hooks/useUser';
import { authenticator } from 'modules/wolt-auth';

import { StyledSupportLayerPage } from './components/StyledSupportLayerPage';
import { SupportLayerProviderProps } from './types';
import { handleDisplayChat as _handleDisplayChat, handleError } from './utils';
import { handleTelemetryEvent } from '../../telemetry';

type SupportLayerProps = {
  handleDisplayChat?: SupportLayerProviderProps['onDisplayChat'];
  pageHeader?: ReactNode;
} & ComponentProps<'div'>;

export const SupportLayer = ({ handleDisplayChat = _handleDisplayChat, pageHeader, className }: SupportLayerProps) => {
  const { locale: userLocale } = useIntl();
  const { user } = useUser();

  if (!user?.country) {
    return null;
  }

  return (
    <>
      {pageHeader}

      <SupportLayerProvider
        appApiBaseUrl={process.env.SUPPORT_FUNNEL_API_URI}
        getAccessToken={authenticator.getAccessToken}
        appType="wolt-merchant-admin"
        appLanguage={userLocale}
        appCountry={user.country}
        appVersion={process.env.APP_REVISION}
        onDisplayChat={handleDisplayChat}
        onError={handleError}
        onTelemetryEvent={handleTelemetryEvent}
      >
        <StyledSupportLayerPage className={className} maxWidth={700} />
      </SupportLayerProvider>
    </>
  );
};
